import { useRouter } from 'next/router';
import { useState, useRef, useCallback, useEffect } from 'react';

const useHoverIntent = ({ inDelay, outDelay, onHoverExitCallback, onHoverCallback }) => {
    const [isHovering, setIsHovering] = useState(false);
    const intentRef = useRef(null);
    let timer = 0;
    const clear = () => {
        if (timer) {
            clearTimeout(timer);
        }
    };
    const changeState = (bool) => {
        clear();
        if (bool && onHoverCallback) {
            onHoverCallback();
        }
        if (!bool && onHoverExitCallback) {
            onHoverExitCallback();
        }
        return setIsHovering(bool);
    };
    const handleEvent = useCallback((e) => {
        clear();
        const attemptingHover = e.type === 'mouseover';
        timer = window.setTimeout(() => changeState(attemptingHover), attemptingHover ? inDelay : outDelay);
    }, [inDelay, outDelay, onHoverCallback, onHoverExitCallback]);
    useEffect(() => {
        const { current } = intentRef;
        if (current) {
            current.addEventListener('mouseover', handleEvent);
            current.addEventListener('mouseleave', handleEvent);
        }
        return () => {
            clear();
            if (current) {
                current.removeEventListener('mouseover', handleEvent);
                current.removeEventListener('mouseleave', handleEvent);
            }
        };
    }, [handleEvent]);
    const { asPath, locale } = useRouter();
    useEffect(() => {
        setIsHovering(false);
    }, [asPath, locale]);
    return [isHovering, intentRef, setIsHovering];
};

export { useHoverIntent as default };
//# sourceMappingURL=useHoverIntent.js.map
